import Rx from "rxjs/Rx";

/**
 * {BaseTypeFilterComponent}
 */
export const typeFilterClickedSource = new Rx.Subject();
export const typeFilterClicked$ = typeFilterClickedSource.asObservable();
/*
 * - Produces typeFilterClicked$ onClick
 * - Produces visual changes for type filters
 */
export class BaseTypeFilterComponent {
    /**
     * @param {Object} node - Jquery node. Unique for every BaseTypeFilterComponent class instance.
     */
    constructor(node) {
        this.node = node;

        // properties from HTML data arguments
        this.premiseIds = [];
        this.index = null;
        this.initializeBase();
    }

    initializeBase() {
        if (this.node) {
            this.parseBaseArgs();
            this.initBaseOnClick();
        }
    }

    setActiveState() {
        this.node.find(".custom-type-filter-component-figure").addClass("active");
    }

    setPassiveState() {
        this.node.find(".custom-type-filter-component-figure").removeClass("active");
    }

    initBaseOnClick() {
        const scope = this;
        this.node.on("click",
            () => {
                typeFilterClickedSource.next(scope);
            });
    }

    parseBaseArgs() {
        this.index = parseInt(this.node.data("index"), 10);

        const possiblePremiseIds = this.node.data("ids");
        if (possiblePremiseIds) {
            this.premiseIds = possiblePremiseIds.split(";");
        }
    }
}
